import { CommonModule } from "@angular/common";
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from "@angular/core";
import { MatDialogModule } from "@angular/material/dialog";
import "@enersis/gp-components/gp-icon";
import "@enersis/gp-components/gp-modal";
import { ButtonComponent } from "src/app/shared/ui/button/button.component";
import { EneButtonModule } from "src/app/shared/ui/button/legacy/button.module";
import { DialogFrameComponent } from "./dialog-frame.component";

@NgModule({
  declarations: [DialogFrameComponent],
  imports: [CommonModule, MatDialogModule, EneButtonModule, ButtonComponent],
  exports: [DialogFrameComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class DialogFrameModule {}
